var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllSuggested8(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 60V40C10 32.0435 13.1607 24.4129 18.7868 18.7868C24.4129 13.1607 32.0435 10 40 10C47.9565 10 55.5871 13.1607 61.2132 18.7868C66.8393 24.4129 70 32.0435 70 40V60",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 63.3337C70 65.1018 69.2976 66.7975 68.0474 68.0477C66.7971 69.2979 65.1014 70.0003 63.3333 70.0003H60C58.2319 70.0003 56.5362 69.2979 55.286 68.0477C54.0357 66.7975 53.3333 65.1018 53.3333 63.3337V53.3337C53.3333 51.5655 54.0357 49.8699 55.286 48.6196C56.5362 47.3694 58.2319 46.667 60 46.667H70V63.3337ZM10 63.3337C10 65.1018 10.7024 66.7975 11.9526 68.0477C13.2029 69.2979 14.8986 70.0003 16.6667 70.0003H20C21.7681 70.0003 23.4638 69.2979 24.714 68.0477C25.9643 66.7975 26.6667 65.1018 26.6667 63.3337V53.3337C26.6667 51.5655 25.9643 49.8699 24.714 48.6196C23.4638 47.3694 21.7681 46.667 20 46.667H10V63.3337Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllSuggested8);
export default __webpack_public_path__ + "static/media/allSuggested8.5ecf189c9e49f7c855c2c0ce12afe2bf.svg";
export { ForwardRef as ReactComponent };